import React, { useEffect, useState, createContext, useRef, useCallback } from 'react';
import dataconnection from '../../../api/DataConnection/dataconnection'
import DatalayerandTooling from '../../../api/DatalayerandTooling'

// Create context object using createContext
export const DataContext = createContext();

// Create context provider
export const DataProvider = ({ children, variableMode = false }) => {
    const [data, setData] = useState(5);
    const [connections, setConnections] = useState(undefined);
    const [turboTools, setTurboTools] = useState([]);
    const [toolapiendpoint,setToolapiendpoint] = useState(undefined);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const isMountedRef = useRef(true);

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        }
    }, []);

    const loaddata = () => {
        setLoading(true);
        setError(null);
        dataconnection.getConnectionList({}).then( res => {
            if (!isMountedRef.current) return;
            // Ensure connections is always an array
            setConnections(Array.isArray(res) ? res : [])
            setLoading(false);
        }).catch((error) => {
            console.error('Error loading connections:', error);
            if (!isMountedRef.current) return;
            setConnections([]);
            setError('Failed to load connections. Please refresh the page.');
            setLoading(false);
        });
    }

    const loadTool = (workspace_id) => {
        DatalayerandTooling.getNewturboTool({workspace_id:workspace_id}).then((res) =>{
            if (!isMountedRef.current) return;
            setTurboTools(Array.isArray(res.data) ? res.data : [])
        }).catch((error) => {
            console.error('Error loading turbo tools:', error);
            if (!isMountedRef.current) return;
            setTurboTools([]);
        });
    }

    const loadToolApiendpoint = useCallback(() => {
        const loader = variableMode ? dataconnection.getVariableApiConnectionList : dataconnection.getDataApiConnectionList;
        loader({}).then((res) =>{
            if (!isMountedRef.current) return;
            setToolapiendpoint(Array.isArray(res.data) ? res.data : [])
        }).catch((error) => {
            console.error('Error loading tool API endpoints:', error);
            if (!isMountedRef.current) return;
            setToolapiendpoint([]);
        });
    }, [variableMode]);

    useEffect(() => {
        loaddata();
        loadToolApiendpoint();
        // cleanup handled by isMountedRef in async callbacks
    }, [variableMode, loadToolApiendpoint]);

    const updateData = (updatedData) => {
        setData(updatedData);
    };
    
    const updateConeection = (data) => {
        setConnections(data)
    }

    const updateTurboToolsWithapi = (updatedata = turboTools) => {
        setTurboTools([...updatedata])
    }


    return (
        <DataContext.Provider value={{ 
            data, 
            updateData,
            connections, 
            updateConeection,
            updateTurboToolsWithapi,
            turboTools,
            loadTool,
            loaddata,
            toolapiendpoint,
            loadToolApiendpoint,
            loading,
            error
            }}>
            {children}
        </DataContext.Provider>
    );
};
